import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledDateHeader = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        margin: ${spacing * 4}px 0;
    `
)
